/* eslint-disable */

slideshare_object.toggleSiblings = function (
  tabToShow,
  tabToHide,
  contentToShow,
  contentToHide
) {
  $(tabToShow).show()
  $(tabToHide).hide()
  $(contentToShow).show()
  $(contentToHide).hide()
}

//Array of slideview toolbar objects
slideshare_object.slideviewInteraction = function () {
  this.slideviewInteractionObjects = {};
}

slideshare_object.slideviewInteraction.prototype.hideAll = function (
  tabToSkip
) {
  for (var key in this.slideviewInteractionObjects) {
    if (this.slideviewInteractionObjects.hasOwnProperty(key)) {
      if (key !== tabToSkip) {
        if (this.slideviewInteractionObjects[key].hide) {
          this.slideviewInteractionObjects[key].hide()
        }
      }
    }
  }

  // Hide share modal if it's visible and a different action was specified
  tabToSkip !== "msharing" &&
    $(".modal-share").is(":visible") &&
    $.slideshareEventManager &&
    $.slideshareEventManager.trigger("playershare")
}
